import {
  GroupCode,
  GroupCodeDescription,
  GroupDescription,
  GroupSecurity,
} from '@quromedical/fhir-common';
import type {
  Group,
  GroupAddMembersRequest,
  GroupGetAllParams,
  GroupGetResponse,
} from '@quromedical/models';
import type { Field, SelectOption } from 'components/types';

export const initialData: Partial<Group> = {
  active: true,
  permissions: [],
  name: '',
  type: undefined,
  organization: undefined,
};

export const initialMembers: Partial<GroupAddMembersRequest> = {
  members: [],
};

export const permissions = Object.values(GroupSecurity).map<SelectOption>(
  (code) => ({
    value: code,
    display: GroupDescription[code as PermissionDescription] || code,
  }),
);

export const typeOptions = Object.values(GroupCode).map<SelectOption>(
  (code) => ({
    value: code,
    display: GroupCodeDescription[code] || code,
  }),
);

export const initialSearch: GroupGetAllParams = {
  code: undefined,
};

export const searchFields: Field<GroupGetAllParams>[] = [
  {
    subfields: [
      {
        type: 'combobox-single',
        key: 'code',
        label: 'Type',
        fetcher: [
          {
            display: 'All',
            value: undefined,
          },
          ...typeOptions,
        ],
      },
    ],
  },
];

export type TableGroup = GroupGetResponse;

export type PermissionDescription = keyof typeof GroupDescription;

export const getCodeDescription = (code?: GroupCode): string | undefined => {
  if (!code) {
    return undefined;
  }

  return GroupCodeDescription[code];
};
